// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"373":"ed0cd7ff","448":"9b704be6"}[chunkId] + ".js";
};